import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IncentiveHeader } from '../../components/Incentive/IncentiveHeader';

export const IncentiveHolder: React.FC = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const holders = [
    { id: '1', code: 'DIST-9928', name: 'Krishna Traders', incentive: 'Distributor Volume Sprint (INC-2025-018)', city: 'Vashi/ Mumbai', targetAchieved: 250, rewardClaimed: '₹1,500', status: 'Active' },
    { id: '2', code: 'DIST-9929', name: 'Metro Supermarket Depot', incentive: 'Dealer New Outlet Push (INC-2025-012)', city: 'Vasai/ Mumbai', targetAchieved: 8, rewardClaimed: '₹500', status: 'Inactive' },
    { id: '3', code: 'DIST-9930', name: 'Om Sai Enterprises', incentive: 'Q1 Scheme Builder (INC-2025-021)', city: 'Thane', targetAchieved: 180, rewardClaimed: '₹2,000', status: 'Active' },
    { id: '4', code: 'DIST-9931', name: 'Shree Dairy Distributors', incentive: 'Repeat Order Booster (INC-2025-027)', city: 'Andheri/ Mumbai', targetAchieved: 120, rewardClaimed: '₹800', status: 'Active' },
  ];

  const filteredHolders = holders.filter(
    (h) =>
      h.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      h.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      h.incentive.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen pb-12">
      <IncentiveHeader
        title="Incentive Holders"
        showBack={true}
        onBackClick={() => navigate('/incentive')}
        showActions={false}
      />

      <div className="bg-white rounded-2xl p-5 md:p-6 border border-gray-100 shadow-sm">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
          <div>
            <h2 className="text-lg font-bold text-gray-900">Active Incentive Holders & Payout Performance</h2>
            <p className="text-xs text-gray-400">Track distributors benefiting from volume incentive programs</p>
          </div>
          <input
            type="text"
            placeholder="Search holder name, code, program..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="bg-white border border-gray-300 focus:border-[#B71C1C] outline-none text-xs rounded-xl py-2 px-4 w-72"
          />
        </div>

        <div className="overflow-x-auto border border-gray-100 rounded-xl">
          <table className="w-full text-left text-xs md:text-sm">
            <thead className="bg-[#FFF9E6] text-gray-600 font-semibold">
              <tr>
                <th className="py-3.5 px-4">Distributor Code</th>
                <th className="py-3.5 px-4">Distributor Name</th>
                <th className="py-3.5 px-4">Assigned Incentive</th>
                <th className="py-3.5 px-4">Location</th>
                <th className="py-3.5 px-4 text-center">Target Achieved</th>
                <th className="py-3.5 px-4 text-center">Reward Earned</th>
                <th className="py-3.5 px-4 text-center">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {filteredHolders.map((holder) => (
                <tr key={holder.id} className="hover:bg-gray-50 transition-colors">
                  <td className="py-3.5 px-4 font-mono text-gray-500 font-medium">{holder.code}</td>
                  <td className="py-3.5 px-4 font-bold text-gray-800">{holder.name}</td>
                  <td className="py-3.5 px-4 text-[#B71C1C] font-semibold">{holder.incentive}</td>
                  <td className="py-3.5 px-4 text-gray-600">{holder.city}</td>
                  <td className="py-3.5 px-4 text-center font-bold text-gray-700">{holder.targetAchieved} Units</td>
                  <td className="py-3.5 px-4 text-center">
                    <span className="bg-emerald-50 text-[#16A34A] font-bold px-2.5 py-0.5 rounded border border-emerald-200 text-xs">
                      {holder.rewardClaimed}
                    </span>
                  </td>
                  <td className="py-3.5 px-4 text-center text-xs text-[#828282]">
                    <span className={`px-2.5 py-0.5 text-[10px] font-bold rounded-full ${
                      holder.status === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'
                    }`}>
                      {holder.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
